import {module} from './module';

export const functionality = function (item = null) {
    return {
        id: item == null ? null : item.id,
        label: item == null ? null : item.label,
        details: item == null ? null : item.details,
        hasValue: item == null ? false : item.hasValue,
        isActive: item == null || item.isActive == undefined ? false : item.isActive,
        enabled: item == null || item.enabled == undefined ? false : item.enabled,
        deleted: item == null || item.deleted == undefined ? false : item.deleted,
        module: module(item == null ? null : item.module)
    };
};
